class RAMQDoctor {
    public FirstName: string;
    public LastName: string;
    public Class: string; // premier digit du # a 7 chriffre de RAMQ
    public Licence: string; // 5 digit CMQ
    public NoGMF: string;
}

export { RAMQDoctor };
